import { AfterViewInit, Directive, ElementRef, HostListener, OnDestroy } from '@angular/core';

@Directive({
    selector: '[tooltipFocusHandler]',
    standalone: true,
})
export class TooltipFocusHandlerDirective implements AfterViewInit, OnDestroy {
    private buttonElement: HTMLButtonElement | null = null;

    constructor(private el: ElementRef) {}

    ngAfterViewInit(): void {
        const pButton = this.el.nativeElement as HTMLElement;
        if (pButton.tagName.toLowerCase() === 'p-button') {
            this.buttonElement = pButton.querySelector('button');
            this.buttonElement?.addEventListener('focus', this.dispatchFocusEvent);
            this.buttonElement?.addEventListener('blur', this.dispatchBlurEvent);
        }
    }

    ngOnDestroy(): void {
        this.buttonElement?.removeEventListener('focus', this.dispatchFocusEvent);
        this.buttonElement?.removeEventListener('blur', this.dispatchBlurEvent);
    }

    private dispatchFocusEvent() {
        if (this.dispatchTooltipEvent) this.dispatchTooltipEvent('mouseenter');
    }

    private dispatchBlurEvent() {
        if (this.dispatchTooltipEvent) this.dispatchTooltipEvent('mouseleave');
    }

    private dispatchTooltipEvent(eventType: string) {
        const appEllipsisTooltip = this.el.nativeElement.querySelector('app-ellipsis-tooltip')?.firstChild;
        if (appEllipsisTooltip) {
            appEllipsisTooltip.dispatchEvent(new Event(eventType));
            return;
        }

        this.el.nativeElement.dispatchEvent(new Event(eventType));
    }

    @HostListener('focus') onFocus() {
        this.dispatchFocusEvent();
    }

    @HostListener('blur') onBlur() {
        this.dispatchBlurEvent();
    }
}
